module.exports = {
      id: "mail-usage",
      viewBox: "0 0 19 16",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#mail",
      toString: function () {
        return this.url;
      }
    }